"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityDocuments = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const file_upload_entity_1 = require("./file-upload.entity");
let OpportunityDocuments = class OpportunityDocuments {
    constructor(id, opportunityId, documentId) {
        this.id = id;
        this.opportunityId = opportunityId;
        this.documentId = documentId;
    }
};
exports.OpportunityDocuments = OpportunityDocuments;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDocuments.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDocuments.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDocuments.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.opportunityDocuments, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDocuments.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, (fileupload) => fileupload.opportunityDocuments, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDocuments.prototype, "document", void 0);
exports.OpportunityDocuments = OpportunityDocuments = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_document_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number])
], OpportunityDocuments);
